module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/winnerFemale-bc441601feb728735b7caef6c2715913.png";